module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point2_3-1f017a64d6741be5d084066aacb05345.jpg";